import { render, staticRenderFns } from "./picoRegister.vue?vue&type=template&id=003ded46&scoped=true"
import script from "./picoRegister.vue?vue&type=script&lang=js"
export * from "./picoRegister.vue?vue&type=script&lang=js"
import style0 from "./picoRegister.vue?vue&type=style&index=0&id=003ded46&prod&scoped=true&lang=css"
import style1 from "./picoRegister.vue?vue&type=style&index=1&id=003ded46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ded46",
  null
  
)

export default component.exports